import { createFileRoute, redirect } from '@tanstack/react-router';

import { AuthDescription } from '@/components/features/auth/auth-description';
import { VerifyForm } from '@/components/features/auth/forms/verify-form';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { PublicPage } from '@/components/ui/layout/public-page';
import { getPreviewOrganizationQuery } from '@/queries/getPreviewOrganizationQuery';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { invitationSearchSchema } from '../invitation';

export const Route = createFileRoute('/_public/verify')({
  component: VerifyComponent,
  validateSearch: (search) => invitationSearchSchema.parse(search),
  beforeLoad: ({ context }) => {
    const isAuthenticated = context.isAuthenticated;

    if (isAuthenticated) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function VerifyComponent() {
  const search = Route.useSearch();
  const { t } = useTranslation();

  const { data: previewOrganization } = useQuery(
    getPreviewOrganizationQuery({
      organizationId: search.organizationId,
      invitationCode: search.invitationCode,
    })
  );

  return (
    <PublicPage.Layout>
      <PublicPage.Header />
      <Card className="w-full max-w-md mx-auto">
        <CardHeader>
          <CardTitle className="text-2xl">{t('auth.verify.title')}</CardTitle>
          <AuthDescription
            type="verify"
            organizationName={previewOrganization?.name}
          />
        </CardHeader>

        <CardContent>
          <VerifyForm
            invitationFlow={{
              invitationEmail: previewOrganization?.invitationEmail,
              organizationId: search.organizationId,
              invitationCode: search.invitationCode,
            }}
          />
        </CardContent>
      </Card>
    </PublicPage.Layout>
  );
}
